import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=54b3e887&scoped=true&"
import script from "./AlbumList.vue?vue&type=script&lang=js&"
export * from "./AlbumList.vue?vue&type=script&lang=js&"
import style0 from "./AlbumList.vue?vue&type=style&index=0&id=54b3e887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3e887",
  null
  
)

export default component.exports